import React from 'react';
import { Lien, Liens } from 'pages/Search/models';
import { createSelector } from 'reselect';
import LiensListItem from '../LiensListItem/LiensListItem';
import { Empty, Row, Col, Radio, Tooltip } from 'antd';
import { BasicTable, getDataTypeName, tabSelector } from 'common';
import { TableHeader } from '..';
import { useDispatch, useSelector } from 'react-redux';
import { searchExportTypeUpdate, exportTypeSelector } from 'pages/Search';
import RadioGroup from 'antd/lib/radio/group';
import OptionalLienParameters from '../OptionalLienParameters/OptionalLienParameters';
import { ResultTypeName } from 'pages/Search/Search.types';

const selector = createSelector(
  exportTypeSelector,
  tabSelector,
  (getExportType, tabName) => ({
    getExportType,
    tabName,
  }),
);

const LiensList: React.FC<{
  searchId: number;
  liens: Liens;
  groupName: string;
  compName: string;
  resultType: ResultTypeName;
  resultItemIndex: number;
}> = ({
  searchId,
  groupName,
  compName,
  liens: { header, items, from, to, bookTypeText },
  resultType,
  resultItemIndex,
}) => {
  const dispatch = useDispatch();
  const { getExportType, tabName } = useSelector(selector);

  const exportType = React.useMemo(() => {
    // @ts-ignore:
    return getExportType(
      getDataTypeName(tabName),
      // @ts-ignore:
      compName,
      resultItemIndex,
      resultType,
    );
  }, [compName, getExportType, resultItemIndex, tabName, resultType]);

  const exportTypeHandler = React.useCallback(
    ({ target: { value } }: any) => {
      dispatch(
        searchExportTypeUpdate(
          getDataTypeName(tabName),
          // @ts-ignore:
          compName,
          value,
          resultItemIndex,
          resultType,
        ),
      );
    },
    [compName, dispatch, groupName, tabName, resultType],
  );

  return !!items.length ? (
    <>
      <TableHeader
        title={`${header}`}
        items={items}
        group={groupName}
        documentType="liens"
        tabName={tabName}
        from={from}
        to={to}
        bookTypeText={bookTypeText}
        resultType={resultType}
        resultItemIndex={resultItemIndex}
      />
      <Row type="flex" justify="end" align="middle">
        <Col>
          <Tooltip title={'Export Type'}>
            <Row>Export Type:</Row>
            <Row>
              <RadioGroup value={exportType} onChange={exportTypeHandler}>
                <Radio value={'summary'}>Summary</Radio>
                <Radio value={'details'}>Details</Radio>
              </RadioGroup>
            </Row>
          </Tooltip>
        </Col>
      </Row>
      <BasicTable
        items={items}
        renderRow={(text: string, record: Lien, index: number) => {
          return (
            <LiensListItem
              searchId={searchId}
              key={record.guid}
              lien={record}
              index={index}
              resultType={resultType}
              resultItemIndex={resultItemIndex}
            />
          );
        }}
      />
    </>
  ) : (
    <>
      <Row type="flex" justify="center" align="middle">
        <Empty
          description={
            <>
              {`No Liens Found (${header})`}
              <OptionalLienParameters
                from={from}
                to={to}
                bookTypeText={bookTypeText}
              />
            </>
          }
        ></Empty>
      </Row>
    </>
  );
};

export default React.memo(LiensList);
